import { render, staticRenderFns } from "./dataread.vue?vue&type=template&id=34aedc03&scoped=true"
import script from "./dataread.vue?vue&type=script&lang=js"
export * from "./dataread.vue?vue&type=script&lang=js"
import style0 from "./dataread.vue?vue&type=style&index=0&id=34aedc03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aedc03",
  null
  
)

export default component.exports